const wowApp = require('angular').module('wowApp.wallet');

const { creditCardAddBaseComponentDefinition } = require('./credit-card-add-base.component');
const { creditCardItemComponentDefinition } = require('./credit-card-item.component');
const { creditCardItemEditComponentDefinition } = require('./credit-card-item-edit.component');

wowApp.component('wowCreditCardAddBase', creditCardAddBaseComponentDefinition);
wowApp.component('wowCreditCardItem', creditCardItemComponentDefinition);
wowApp.component('wowCreditCardItemEdit', creditCardItemEditComponentDefinition);



// WEBPACK FOOTER //
// ./src/wallet/creditcard/index.js